import { render } from "./ChangeLog.vue?vue&type=template&id=71e3333a&scoped=true"
import script from "./ChangeLog.vue?vue&type=script&lang=js"
export * from "./ChangeLog.vue?vue&type=script&lang=js"

import "./ChangeLog.vue?vue&type=style&index=0&id=71e3333a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/marvel-lcg-randomizer/marvel-lcg-randomizer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e3333a"]])

export default __exports__